<template>
    <div class="employees-sub-projects-single">
        <div class="placeholder">
            <div class="placeholder__heading">
                {{ data.first_name }} {{ data.last_name }}
            </div>
            <div class="placeholder">
                
                <vue-good-table
                    :columns="columns"
                    :rows="data.sub_projects"
                    :search-options="searchOptions"
                    :pagination-options="paginationOptions"
                    :sort-options="sortOptions"
                    :styleClass="styleClass"
                >
                    <div slot="emptystate">
                        Ingen data ...
                    </div>
                    <template slot="table-row" slot-scope="props">
                        <div class="coverage-cell" v-if="props.column.field == 'coverage_percent'">
                            {{ props.row.coverage_percent | coveragePercent }} 
                            <div
                                v-if="props.row.coverage_percent !== null"
                                class="coverage-indicator"
                                :class="{'bad': props.row.coverage_percent < $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.high.value}"
                            />
                        </div>
                        <div v-else-if="props.column.field == 'description'" class="table-column__description" :title="props.row.description">
                            {{ props.row.description }}
                        </div>
                        <div v-else-if="props.column.field == 'coverage'">
                            {{ props.row.coverage | currency }}
                        </div>
                        <div v-else-if="props.column.field == 'invoices_total'" style="text-align:left;">
                            {{ props.row.invoices_total | currency }}
                        </div>
                        <div v-else-if="props.column.field == 'total_expenses'" style="text-align:left;">
                            {{ props.row.total_expenses | currency }}
                        </div>
                        <div class="coverage-cell" v-else-if="props.column.field == 'coverage_per_hour'">
                            {{ props.row.coverage_per_hour | currency }} 
                            <div
                                v-if="props.row.coverage_per_hour !== null"
                                class="coverage-indicator"
                                :class="{'bad': props.row.coverage_per_hour < $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.high.value}"
                            />
                        </div>
                        <div v-else-if="props.column.field == 'name'" class="table-column__description" :title="props.row.name ? props.row.name : '-'">
                            {{ props.row.name ? props.row.name : '-' }}
                        </div>
                        <div v-else-if="props.column.field == 'budget'">
                            -
                        </div>
                        <div v-else-if="props.column.field == 'efficiency'">
                            -
                        </div>
                        <div v-else :title="props.formattedRow[props.column.field]">
                            {{ props.formattedRow[props.column.field] }}
                        </div>
                    </template>
                </vue-good-table>

            </div>
        </div>

    </div>
</template>

<script>

export default {
    props: {
        data: {
            required: true
        }
    },
    data () {
        return {
            selectedRow: null,
            rows: [],
            columns: [
                { label: 'Ordre', field: 'case_number' },
                { label: 'Opgave', field: 'description', type: 'string' },
                // { label: 'Antal', field: 'count', type: 'number' },
                { label: 'Budget omk.', field: 'budget', type: 'string' },
                { label: 'Realiseret', field: 'total_expenses', type: 'number' },
                { label: 'Eff. grad', field: 'efficiency', type: 'string' }
                /* { label: 'Omsætning', field: 'invoices_total', type: 'number' },
                { label: 'DB', field: 'coverage', type: 'number' },
                { label: 'DG', field: 'coverage_percent', type: 'number' },
                { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' } */
            ],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true
            },
            styleClass: 'vgt-table'
        }
    }
}
</script>



// WEBPACK FOOTER //
// employeesSubProjectsSingle.vue?0026dd90